// Display helpers for the admin nurse page's activity section, kept separate so
// they're testable.

const DAY_MS = 24 * 60 * 60 * 1000;
// No handoff in this many days (for an account at least this old) is flagged.
export const INACTIVE_DAYS = 14;

// "Today", "Yesterday", "5 days ago", or 'Never' with no time.
export function daysAgo(iso, now = new Date()) {
  if (!iso) return 'Never';
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return 'Never';
  const startOf = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.round((startOf(now) - startOf(then)) / DAY_MS);
  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  return `${days} days ago`;
}

// Whether to flag the nurse as not using the app: no handoff in INACTIVE_DAYS
// days, unless their account is newer than that (they may not have worked yet).
export function isInactive(activity, now = new Date()) {
  if (!activity) return false;
  const ageMs = (iso) => (iso ? now.getTime() - new Date(iso).getTime() : Infinity);
  if (ageMs(activity.accountCreatedAt) < INACTIVE_DAYS * DAY_MS) return false;
  return ageMs(activity.lastHandoffAt) >= INACTIVE_DAYS * DAY_MS;
}

// "12 handoffs", "1 handoff".
export const handoffs = (n) => `${n} handoff${n === 1 ? '' : 's'}`;
